<template>
  <div class="body-1 body-content">
    <div class="mla mb-3" v-html="mla"></div>
    <div class="apa mb-3" v-html="apa"></div>
    <div class="chicago mb-3" v-html="chicago"></div>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'Citation',

    props: ['article'],

    computed: {
      todaysDate: function() {
        return moment().format('MMMM D, YYYY');
      },
      articleUrl: function() {
        const category = this.article.categories.length > 0 ? this.article.categories[0].slug : 'default';

        return `${location.protocol}//${location.host}/student/${category}/${this.article.slug}`;
      },
      publishYear: function() {
        if (!this.article.updated_at) {
          return '';
        }

         return moment(this.article.updated_at).format('YYYY');
      },
      mla: function () {
        return `<p><strong>MLA</strong><br>${this.article.author}. "${this.article.first_name} ${this.article.last_name}<em>.</em>"<em> Lerner Sports</em>, Lerner Publishing Group, ${this.publishYear}, ${this.articleUrl}. Accessed ${this.todaysDate}.</p>`;
      },
      apa: function () {
        return `<p><strong>APA</strong><br>${this.article.author}. (${this.publishYear}). ${this.article.first_name} ${this.article.last_name}. <em>Lerner Sports</em>. Retrieved from ${this.articleUrl}.</p>`;
      },
      chicago: function () {
        return `<p><strong>Chicago</strong><br>${this.article.author}. "${this.article.first_name} ${this.article.last_name}." Lerner Sports. Accessed ${this.todaysDate}. ${this.articleUrl}.</p>`;
      }
    }
  }
</script>

